export function accentFold(str)
{
    return str.replace(/([àáâãäå])|([ç])|([èéêë])|([ìíîï])|([ñ])|([òóôõöø])|([ß])|([ùúûü])|([ÿ])|([æ])/g, (st, a, c, e, i, n, o, s, u, y, ae) =>
    {
        if (a) return 'a'
        else if (c) return 'c'
        else if (e) return 'e'
        else if (i) return 'i'
        else if (n) return 'n'
        else if (o) return 'o'
        else if (s) return 's'
        else if (u) return 'u'
        else if (y) return 'y'
        else if (ae) return 'ae'

        return ''
    })
}

export function anagrams(str)
{
    if (str.length <= 2) return str.length === 2 ? [str, str[1] + str[0]] : [str]

    return str.split('').reduce((acc, letter, i) =>
    {
        anagrams(str.slice(0, i) + str.slice(i + 1)).map(val => acc.push(letter + val))
        return acc
    }, [])
}

export function slugify(text = '')
{
    const a = 'àáäâèéëêìíïîòóöôùúüûñçßÿœæŕśńṕẃǵǹḿǘẍźḧ·/_,:;άαβγδεέζήηθιίϊΐκλμνξοόπρσςτυϋύΰφχψωώ'
    const b = 'aaaaeeeeiiiioooouuuuncsyoarsnpwgnmuxzh------aavgdeeziitiiiiklmnxooprsstyyyyfhpoo'
    const p = new RegExp(a.split('').join('|'), 'g')

    return text.toString().trim().toLowerCase()
        .replace(/ου/g, 'ou')
        .replace(/ευ/g, 'eu')
        .replace(/θ/g, 'th')
        .replace(/ψ/g, 'ps')
        .replace(/\//g, '-')
        .replace(/\s+/g, '-')           // Replace spaces with -
        .replace(p, c => b.charAt(a.indexOf(c)))     // Replace special chars
        .replace(/&/g, '-and-')         // Replace & with 'and'
        .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
        .replace(/\-\-+/g, '-')         // Replace multiple - with single -
        .replace(/^-+/, '')             // Trim - from start of text
        .replace(/-+$/, '')             // Trim - from end of text
}



// WEBPACK FOOTER //
// ./src/scripts/utils/String.js